import * as React from 'react';
import { useHistory } from 'react-router-dom';
import {
  AuthConditionResponseTypes,
  AUTHORIZED,
  HIDE,
  REDIRECT,
  UNAUTHORIZED,
} from '../../Types/Auth';

export interface AuthPermissionAccessObject {
  [index: string]: {
    read?: boolean;
    write?: boolean;
  };
}

export interface IAuthorizedComponentProps {
  children?: React.ReactNode;
  userPermissions: AuthPermissionAccessObject;
  requiredPermissions: string[][];
  requiredAccess: { read?: boolean; write?: boolean };
  action?: AuthConditionResponseTypes;
  hiddenComponent?: JSX.Element;
  redirectPath?: string;
}

export const AuthorizedComponent: React.FC<IAuthorizedComponentProps> = (
  props
) => {
  const history = useHistory();

  const [hidden, setHidden] = React.useState<boolean>(false);
  const [authorized, setAuthorized] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    if (props.userPermissions) {
      setLoading(false);
    }
  }, [props.userPermissions]);

  React.useEffect(() => {
    // This auth condition logic needs to be reworked to account for not access specified in permissions, but parent access is specified, where it should then be using parent access.

    const authCondition = (): AuthConditionResponseTypes => {
      let trackPermissionSets = false;
      props.requiredPermissions.forEach((reqPerms) => {
        // set this to false if any perms in this set fail. perm1 && perm2 === true
        let allPermsInSetPassed = true;

        reqPerms.forEach((reqPerm) => {
          // check to make sure permissions for the current path exist
          if (props.userPermissions && props.userPermissions[reqPerm]) {
            //if the read and/or write aren't the same as the values passed in, set passed set to false
            if (
              typeof props.requiredAccess.read === 'boolean' &&
              typeof props.requiredAccess.write === 'boolean'
            ) {
              if (
                !!props.requiredAccess.read !==
                  !!props.userPermissions[reqPerm]?.read ||
                !!props.requiredAccess.write !==
                  !!props.userPermissions[reqPerm]?.write
              ) {
                allPermsInSetPassed = false;
              }
            } else if (typeof props.requiredAccess.read === 'boolean') {
              if (
                !!props.requiredAccess.read !==
                !!props.userPermissions[reqPerm]?.read
              ) {
                allPermsInSetPassed = false;
              }
            } else if (typeof props.requiredAccess.write === 'boolean') {
              if (
                !!props.requiredAccess.write !==
                !!props.userPermissions[reqPerm]?.write
              ) {
                allPermsInSetPassed = false;
              }
            } else if (
              props.userPermissions[reqPerm]?.read ||
              props.userPermissions[reqPerm]?.write
            ) {
              allPermsInSetPassed = false;
            }
          } else {
            allPermsInSetPassed = false;
            //   allPermsInSetPassed &&
            //   (props.requiredAccess.read || props.requiredAccess.write);
          }
        });
        if (!trackPermissionSets && allPermsInSetPassed) {
          //set this to true if ANY of the permission sets returned true. permSet1 || permSet2 === true
          trackPermissionSets = true;
        }
      });

      if (trackPermissionSets) {
        return AUTHORIZED;
      }

      return props.action;
    };
    if (!loading) {
      switch (authCondition()) {
        case REDIRECT:
          if (props.redirectPath) {
            history.push(props.redirectPath);
          } else {
            history.push('/');
          }
          break;
        case HIDE:
          setHidden(true);
          break;
        case UNAUTHORIZED:
          history.push('/login');
          break;
        default:
          setAuthorized(true);
      }
    }
  }, [
    props.userPermissions,
    props.requiredPermissions,
    props.requiredAccess,
    loading,
  ]);

  return hidden || !authorized ? (
    props.hiddenComponent ? (
      props.hiddenComponent
    ) : null
  ) : (
    <>{props.children}</>
  );
};
